/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  ZipPackageInfo,
  ZipPackageInfoFromJSON,
  ZipPackageInfoFromJSONTyped,
  ZipPackageInfoToJSON,
} from "./";

/**
 *
 * @export
 * @interface ZipPackageInfoControllerResponse
 */
export interface ZipPackageInfoControllerResponse {
  /**
   *
   * @type {ZipPackageInfo}
   * @memberof ZipPackageInfoControllerResponse
   */
  data?: ZipPackageInfo;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ZipPackageInfoControllerResponse
   */
  error?: ErrorResponse;
}

export function ZipPackageInfoControllerResponseFromJSON(json: any): ZipPackageInfoControllerResponse {
  return ZipPackageInfoControllerResponseFromJSONTyped(json, false);
}

export function ZipPackageInfoControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ZipPackageInfoControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : ZipPackageInfoFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ZipPackageInfoControllerResponseToJSON(value?: ZipPackageInfoControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: ZipPackageInfoToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
